import { render, staticRenderFns } from "./idp-choice-dialog.vue?vue&type=template&id=a88b1bf4&scoped=true&"
import script from "./idp-choice-dialog.vue?vue&type=script&lang=tsx&"
export * from "./idp-choice-dialog.vue?vue&type=script&lang=tsx&"
import style0 from "./idp-choice-dialog.vue?vue&type=style&index=0&id=a88b1bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a88b1bf4",
  null
  
)

export default component.exports